import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-6" }
const _hoisted_5 = { class: "col-6 col-md-6" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-md-12 table-responsive" }
const _hoisted_8 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_9 = { class: "nowrap-celular" }
const _hoisted_10 = { class: "text-center text-nowrap" }
const _hoisted_11 = { class: "row mt-2" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }

import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/paramsService";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
 

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  var controle = reactive({
    filtros: {
      paginaAtual: 1 as number | undefined,
      tamanhoPagina: 20 as number | undefined
    } as unknown as service.Filtros,
    itens: [] as service.Param[],

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    pesquisar();
  })

  async function pesquisar() {

    service.obter(controle.filtros)
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Parâmetros" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Id...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.paramId) = $event)),
              onKeyup: pesquisar
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.paramId]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-primary btn-sm mt-4 float-end",
              to: '/parametros/cadastro'
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "flaticon-plus" }, null, -1),
                _createTextVNode(" Adicionar", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "th-sortable" }, "Id"),
                  _createElementVNode("th", { class: "th-sortable" }, "Empresa"),
                  _createElementVNode("th", null, "Opções")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.paramId), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(item.nomeEmpresa), 1),
                    _createElementVNode("td", _hoisted_10, [
                      _createVNode(_component_RouterLink, {
                        to: '/parametros/cadastro/' + item.paramId,
                        class: "btn btn-outline-primary btn-sm",
                        title: "Editar"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("i", { class: "flaticon-pen" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(controle).itens.length) + " Registros ", 1),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: _unref(controle).filtros.paginaAtual ?? 1,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina ?? 20,
              totalItens: _unref(controle).itens.length,
              onPaginaMudou: pesquisar
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalItens"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})